module.exports = __webpack_public_path__ + "static/IMG_2723-94e5cebb71c32fed169d13128f84ffba.jpg";